<template>
  <div
    ref="toolbarItemRef"
    :class="[
      'toolbar-item-container',
      !isPC && 'toolbar-item-container-h5',
    ]"
  >
    <div
      v-if="isPC || (isH5 && !isH5Emoji && isH5ToolShow)"
      :class="[
        'toolbar-item-container-icon',
        isH5 && 'toolbar-item-container-h5-icon'
      ]"
      @click="toggleToolbarItem"
    >
      <Icon
        :file="props.iconFile"
        class="icon"
        :width="props.iconWidth"
        :height="props.iconHeight"
      />
    </div>
    <div
      v-if="(isH5 && !isH5Emoji && isH5ToolShow)"
      :class="['toolbar-item-container-h5-title']"
    >
      {{ props.title }}
    </div>
    <div
      v-show="showDialog || isH5EmojiShow"
      ref="dialogRef"
      :class="[
        'toolbar-item-container-dialog',
        !isPC && 'toolbar-item-container-h5-dialog',
      ]"
    >
      <BottomPopup
        v-if="props.needBottomPopup && !isPC"
        class="toolbar-bottom-popup"
        :show="showDialog || isH5EmojiShow"
        @touchmove.stop.prevent
        @onClose="onPopupClose"
      >
        <slot />
      </BottomPopup>
      <slot v-else />
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../../adapter-vue';
import { outsideClick } from '@tencentcloud/universal-api';
import Icon from '../../../common/Icon.vue';
import BottomPopup from '../../../common/BottomPopup/index.vue';
import { isPC, isH5 } from '../../../../utils/env';
const __sfc_main = {};
__sfc_main.props = {
  iconFile: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  needDialog: {
    type: Boolean,
    default: true
  },
  iconWidth: {
    type: String,
    default: '20px'
  },
  iconHeight: {
    type: String,
    default: '20px'
  },
  // Whether to display the bottom popup dialog on mobile devices
  // Invalid on PC
  needBottomPopup: {
    type: Boolean,
    default: false
  },
  isH5EmojiShow: {
    type: Boolean,
    default: false
  },
  isH5Emoji: {
    type: Boolean,
    default: false
  },
  isH5ToolShow: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref
  } = vue;
  const props = __props;
  const emits = __ctx.emit;
  const showDialog = ref(false);
  const toolbarItemRef = ref();
  const dialogRef = ref();
  const toggleToolbarItem = () => {
    emits('onIconClick', dialogRef);
    if (isPC) {
      outsideClick.listen({
        domRefs: toolbarItemRef.value,
        handler: closeToolbarItem
      });
    }
    if (!props.needDialog) {
      return;
    }
    toggleDialogDisplay(!showDialog.value);
  };
  const closeToolbarItem = () => {
    showDialog.value = false;
    emits('onDialogClose', dialogRef);
  };
  const toggleDialogDisplay = (showStatus: boolean) => {
    if (showDialog.value === showStatus) {
      return;
    }
    showDialog.value = showStatus;
    switch (showStatus) {
      case true:
        emits('onDialogShow', dialogRef);
        break;
      case false:
        emits('onDialogClose', dialogRef);
    }
  };
  const onPopupClose = () => {
    showDialog.value = false;
  };
  return Object.assign({
    isPC,
    isH5,
    props,
    showDialog,
    toolbarItemRef,
    dialogRef,
    toggleToolbarItem,
    onPopupClose
  }, {
    toggleDialogDisplay
  });
};
__sfc_main.components = Object.assign({
  Icon,
  BottomPopup
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="scss" scoped src="./style/index.scss"></style>
